import { render } from "./ListeVente.vue?vue&type=template&id=5e8fe756&ts=true"
import script from "./ListeVente.vue?vue&type=script&lang=ts"
export * from "./ListeVente.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__